import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { BentoCategory } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import QuestionChip from "components/Styled/QuestionChip";

interface Props {
  topLevelCategories: BentoCategory[];
  expandCategory: (category: BentoCategory) => boolean;
  isSelectAll: (category: BentoCategory) => boolean;
  handleSelectAll: (e: CustomEvent, category: BentoCategory) => void;
  isSelected: (chip: BentoCategory) => boolean;
  selectChip: (Chip: BentoCategory) => void;
}

const DetailedCategoryFormComponent = ({
  topLevelCategories,
  expandCategory,
  isSelectAll,
  handleSelectAll,
  isSelected,
  selectChip,
}: Props) => {
  return (
    <Grid container spacing={2}>
      {topLevelCategories?.map((category, index) => (
        <Grid item xs={12} md={6} lg={4} key={category.id}>
          <Accordion
            square={true}
            sx={{
              boxShadow: "none",
              border: `1px solid ${grey[300]}`,
              borderRadius: "16px",
            }}
            defaultExpanded={expandCategory(category)}
          >
            <AccordionSummary
              sx={{ background: "none", backgroundColor: "none", height: 20 }}
              expandIcon={
                <Box component="i" className="fa-regular fa-chevron-down" />
              }
            >
              <Grid container alignItems="center" gap={1}>
                <Typography
                  noWrap
                  sx={{
                    fontSize: { xs: 10, md: 14 },
                    maxWidth: { xs: 150, md: 300 },
                    textOverflow: "hidden",
                  }}
                >
                  <strong>{category?.name}</strong>
                </Typography>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isSelectAll(category)}
                      icon={
                        <Box
                          component="i"
                          className="fa-regular fa-square"
                          sx={{ ml: 1, color: grey[400] }}
                        />
                      }
                      checkedIcon={
                        <Box
                          component="i"
                          className="fa-solid fa-check"
                          sx={{ ml: 1, color: "green.main" }}
                        />
                      }
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: { xs: 10, md: 13 } }}>
                      Select All{" "}
                    </Typography>
                  }
                  onChange={(e) => handleSelectAll(e, category)}
                  onClick={(e) => e.stopPropagation()}
                />
              </Grid>
            </AccordionSummary>

            <AccordionDetails sx={{ mt: 0 }}>
              <Grid container gap={1}>
                {category?.subcategories?.map((subcategory, index) => (
                  <QuestionChip
                    key={index}
                    label={subcategory.name}
                    onClick={() => selectChip(subcategory)}
                    isSelected={isSelected(subcategory)}
                  />
                ))}

                <QuestionChip
                  key={index}
                  label={"Other"}
                  onClick={() => selectChip(category)}
                  isSelected={isSelected(category)}
                />
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
      ))}
    </Grid>
  );
};

export default DetailedCategoryFormComponent;
